import { render, staticRenderFns } from "./fifth.vue?vue&type=template&id=5c39eb2e&scoped=true&"
import script from "./fifth.vue?vue&type=script&lang=js&"
export * from "./fifth.vue?vue&type=script&lang=js&"
import style0 from "./fifth.vue?vue&type=style&index=0&id=5c39eb2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c39eb2e",
  null
  
)

export default component.exports